import { Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { EmployeeService } from 'src/app/services/employee/employee.service'
import { WebService } from 'src/app/services/api/web.service'
import { OnboardingInsertEmployeeValidator } from '../../../import/validators/insert-employee.validator'
import { UpdateEmployeeValidator } from '../../../import/validators/update-employee.validator'

@Component({
  selector: 'app-employee-step',
  templateUrl: './employee-step.component.html',
  styleUrls: ['./employee-step.component.scss']
})
export class EmployeeStepComponent implements OnInit {
  @Input() form!: FormGroup

  activeTab: 'import' | 'assign' = 'import'

  importValidator: any
  updateValidator: any
  adminAssignmentHistory: any[] = []

  constructor(private empService: EmployeeService, private webService: WebService) {}

  ngOnInit(): void {
    // Same as Employee Summary
    this.importValidator = new OnboardingInsertEmployeeValidator(this.empService, null, this.webService, false)
    this.updateValidator = new UpdateEmployeeValidator(this.empService, null, this.webService)
  }

  /** Triggered when the import wizard completes */
  onImportCompleted(result: any) {
    this.activeTab = 'assign' // Move to admin assignment
  }

  onAssignmentSaved(event: { employees: any[]; company: any; entities: any[] }) {
    const existingIds = new Set(this.adminAssignmentHistory.map(e => e.id))

    const newHistoryEntries = event?.employees
      .filter(emp => !existingIds.has(emp.id))
      .map(emp => ({
        id: emp.id,
        name: emp.display,
        companyAdmin: true,
        entities: event.entities.map(e => e.name)
      }))

    this.adminAssignmentHistory = [...this.adminAssignmentHistory, ...newHistoryEntries]
  }

  /** Go back to import tab */
  goToImport() {
    this.activeTab = 'import'
  }
}
